import { ProviderFeeTiming } from './mapToLutherMortgage.fixtures'

export const mapToLutherFeeTiming: { [key in ProviderFeeTiming]: MortgageProductFeeTiming } = {
  [ProviderFeeTiming.UpFront]: 'UP_FRONT',
  [ProviderFeeTiming.OnCompletion]: 'COMPLETION_TIMING',
  [ProviderFeeTiming.OnEarlyRedemption]: 'EARLY_REDEMPTION',
  [ProviderFeeTiming.OnRedemption]: 'REDEMPTION',
}
